module.exports = __webpack_public_path__ + "static/sat-c20b91ab31653ab6ad6f47508c0c0a90.png";